// Import Firebase
import { initializeApp } from "firebase/app";
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics, logEvent } from "firebase/analytics";


// Firebase configuration object
const firebaseConfig = {
  apiKey: "AIzaSyDkSJ6dK6EgJG7kT0iWVXwztzmoYt2fqew",
  authDomain: "cec-app-a569e.firebaseapp.com",
  projectId: "cec-app-a569e",
  storageBucket: "cec-app-a569e.firebasestorage.app",
  messagingSenderId: "555607931621",
  appId: "1:555607931621:web:23b05c1f4355d51ad0f20c",
  measurementId: "G-282PDN73F8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Analytics
const analytics = getAnalytics(app);


// Export Firestore
export const db = getFirestore(app); // Database
export const auth = getAuth(app); // Authentication